import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Icon } from '@cld/icon';
import { globalTheme } from '@cld/component-theme';
import { withItemContext } from '../ItemContext';
import { SuppportedLayoutTypographySize } from '../types';
import { textSizeVariant } from '../theme';
import { LayoutBaseProps, layoutTypographyMixin, SelectedIcon } from './common';

export type TextItemLayoutProps = LayoutBaseProps;

const Root = styled.div<Required<LayoutBaseProps>>`
  display: flex;
  align-items: center;
  ${textSizeVariant((branch) => layoutTypographyMixin(branch.typographySize as SuppportedLayoutTypographySize))};
  padding: ${textSizeVariant((branch) => branch.paddingTopAndBottom)} ${globalTheme.spacing.sm};

  & > ${Icon} {
    flex-shrink: 0;
    margin-right: ${globalTheme.spacing.sm};
    ${({ isSelected }) =>
      !isSelected &&
      css`
        color: ${globalTheme.palette.contrastLow};
      `}
  }
`;

export const TextPure: FC<TextItemLayoutProps> = ({
  children,
  isSelected = false,
  selectionVariant = 'solid',
  showCheckIconWhenSelected = false,
  size = 'sm',
}) => {
  return (
    <Root size={size} isSelected={isSelected} selectionVariant={selectionVariant} showCheckIconWhenSelected={showCheckIconWhenSelected}>
      {children}
      {isSelected && showCheckIconWhenSelected && <SelectedIcon />}
    </Root>
  );
};

export const Text = withItemContext(TextPure);
